import { Component, Input, OnInit } from '@angular/core';
import { KButtonType } from 'ng-k-button';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { ClaimOutcomeService } from 'src/app/services/claim-outcome.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-claim-outcome',
  templateUrl: './claim-outcome.component.html',
  styleUrls: ['./claim-outcome.component.scss']
})
export class ClaimOutcomeComponent implements OnInit {
  @Input() claimId: any;
  public outcomeTasks: any = [];
  KButtonType = KButtonType;
  constructor(
    private loaderService: GlobalLoadingService,
    private claimOutcomeService: ClaimOutcomeService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.workflowCatOverview(this.claimId)
  }

  public workflowCatOverview(claimID: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimID? claimID : null;
    requestParam.handle = "outcome";
    this.loaderService.startLoadingIndicator('workflowCatOverview');
    
    thisObj.claimOutcomeService.workflowCatOverview(requestParam).subscribe(result => {
      if (result.status == 'Success') {
        this.loaderService.stopLoadingIndicator('workflowCatOverview');
        this.outcomeTasks = result.data.data
      }
    },
    err => {
      console.log(err.error);
    }); 
  }

  public taskAction(task: any, claimID: any) {
    for(let data of task['tasks']) {
      this.router.navigate([data.action, claimID]) 
    }
  }
}
